
<c-app-bar
    :title         = "title"
    :categories    = "categories"
    :enable-search = "false"
>
    <template v-slot:search>
        <!-- Search criteria input -->
        <div class=" ml-3">
            <v-text-field
                outlined
                hide-details
                dense
                v-model="criteria"
                clearable
                clear-icon="mdi-close-circle"

                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
            />
        </div>
        <!-- Search criteria input -->

        <div class="v-flex">
            <c-toolbar-button
                icon     = "mdi-home"
                color    = "primary"
                :size    = "22"
                :tooltip = "$t('home.button')"
                class    = "ml-2"
                @click   = "onHome"
            />

            <slot name="toolbar" />
        </div>
        <div class="pl-5 grow primary--text" style="text-align: center">
            {{ selected }}
        </div>
    </template>
</c-app-bar>
